import { ChakraProps } from "@biblioteksentralen/react";

export const capitalizeFirstLetter: ChakraProps = {
  sx: {
    "&:first-letter": {
      textTransform: "uppercase",
    },
  },
};
